'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var legacy_Typography_Paragraph = require('../../legacy/Typography/Paragraph.js');
var core_Card_Favorite = require('./Favorite.js');
var core_Card_Thumbnail = require('./Thumbnail.js');
var core_Card_Card_style = require('./Card.style.js');
var react = require('@emotion/react');
require('@babel/runtime/helpers/objectWithoutProperties');
require('../../legacy/Typography/Text.js');
require('@styled-system/should-forward-prop');
require('styled-system');
require('@emotion/styled');
require('../Icon/icons/default/Like.js');
require('../../withIconProps-365ff8d5.js');
require('@babel/runtime/helpers/taggedTemplateLiteral');
require('../Icon/icons/illustrations/Like.js');
require('./Favorite.style.js');
require('@babel/runtime/helpers/slicedToArray');
require('react-transition-group/cjs/index');
require('./Thumbnail.style.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var renderPriceBlock = function renderPriceBlock(_ref) {
  var price = _ref.price,
    newPrice = _ref.newPrice;
  if (price && newPrice) {
    return react.jsx(core_Card_Card_style.CardPrice, {
      mt: 4
    }, react.jsx(core_Card_Card_style.NewPrice, null, newPrice), react.jsx(core_Card_Card_style.OriginalPrice, null, price));
  } else if (price) {
    return react.jsx(core_Card_Card_style.CardPrice, {
      mt: 4
    }, price);
  }
};
var Card = function Card(_ref2) {
  var title = _ref2.title,
    location = _ref2.location,
    date = _ref2.date,
    price = _ref2.price,
    favoriteAction = _ref2.favoriteAction,
    _ref2$isFavorite = _ref2.isFavorite,
    isFavorite = _ref2$isFavorite === void 0 ? false : _ref2$isFavorite,
    renderParams = _ref2.renderParams,
    renderBadges = _ref2.renderBadges,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'grid' : _ref2$type,
    _ref2$headerTitle = _ref2.headerTitle,
    headerTitle = _ref2$headerTitle === void 0 ? '' : _ref2$headerTitle,
    newPrice = _ref2.newPrice,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'large' : _ref2$size,
    renderFavorite = _ref2.renderFavorite,
    _ref2$renderThumbnail = _ref2.renderThumbnail,
    renderThumbnail = _ref2$renderThumbnail === void 0 ? function (renderThumbnailProps) {
      return react.jsx(core_Card_Thumbnail.Thumbnail, _extends__default["default"]({
        type: type,
        thumbnailRadius: !headerTitle
      }, renderThumbnailProps));
    } : _ref2$renderThumbnail;
  return react.jsx(React__default["default"].Fragment, null, headerTitle && type === 'list' && react.jsx(core_Card_Card_style.ListCardHeader, null, headerTitle), react.jsx(core_Card_Card_style.SCard, {
    type: type,
    headerTitle: headerTitle
  }, headerTitle && type !== 'list' && react.jsx(core_Card_Card_style.GridCardHeader, null, headerTitle), react.jsx(core_Card_Card_style.SCardThumbnail, {
    type: type
  }, renderThumbnail({
    alt: typeof title === 'string' ? title : ''
  }), renderBadges && react.jsx(core_Card_Card_style.SBadges, null, renderBadges())), react.jsx(core_Card_Card_style.SCardContent, {
    type: type,
    size: size
  }, react.jsx("div", null, react.jsx(core_Card_Card_style.CardTitle, {
    mr: 24
  }, title), renderPriceBlock({
    price: price,
    newPrice: newPrice
  })), react.jsx("div", null, type === 'gallery' ? react.jsx(legacy_Typography_Paragraph.Paragraph8, {
    mt: 8,
    color: "text-global-secondary"
  }, location, " - ", date) : react.jsx(React__default["default"].Fragment, null, react.jsx(legacy_Typography_Paragraph.Paragraph8, {
    mt: 8,
    color: "text-global-secondary"
  }, location), react.jsx(legacy_Typography_Paragraph.Paragraph8, {
    color: "text-global-secondary"
  }, date)), renderParams && react.jsx(core_Card_Card_style.CardParams, {
    mt: 8,
    color: "text-global-secondary"
  }, renderParams())), favoriteAction && react.jsx(core_Card_Favorite.Favorite, {
    favoriteAction: favoriteAction,
    isFavorite: isFavorite,
    size: size,
    renderFavorite: renderFavorite
  }))));
};
Card.Thumbnail = core_Card_Thumbnail.Thumbnail;

exports.Card = Card;
//# sourceMappingURL=Card.js.map
